import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import useCreateConversation from '../../../../../../hooks/conversations/useCreateConversation';
import useDeleteTalentFromPool from '../../../../../../hooks/talents/useDeleteTalentFromPool';
import './mytalentcard.css'
import { starIcon, scheduleIcon, userChefIcon, timerIcon } from '../../../../../../utils/icons';
import useCheckConversation from '../../../../../../hooks/conversations/useCheckConversation';
import useSignedImage from '../../../../../../hooks/useSignedImage';

const MyTalentCard = ({ id,data,employeeId, onDeleteSuccess }) => {
    const { createConversation, isLoading: conversationLoading, error: conversationError } = useCreateConversation();
    const {  conversationExists, isLoading, error, conversation,  checkConversationExistence } = useCheckConversation()
    const { deleteTalentFromPool } = useDeleteTalentFromPool();
    const {} = useCheckConversation()
    const navigate = useNavigate();

    const {name, position, available,schedule, profileImageUrl } = data
    const { imageUrl: signedEmployeeImageUrl } = useSignedImage(profileImageUrl, '/default-employee.png');
    
    useEffect(() => {
      checkConversationExistence(employeeId, 'talent');
    }, [checkConversationExistence]);

    const handleConversationInitiation = async () => {
        if (!conversationLoading) {
            try {
                const newConversation = await createConversation(employeeId, id, 'talent');
              
                if (newConversation) {
                    navigate(`/panel-empresa/inbox-empresa/${newConversation.id}/${employeeId}`);
                } 

            } catch (error) {
                console.error('Error initiating conversation:', error);
            }
        }
    };
    
    const handleDeleteTalent = async () => {
        try {
            await deleteTalentFromPool(id);
            onDeleteSuccess();
        } catch (error) {
            console.error('Error deleting talent:', error);
        }
    };

    const navigateToChat = () => {
        if (conversationExists) {
            navigate(`/panel-empresa/inbox-empresa/${conversation.id}/${employeeId}`);
        } else {
            handleConversationInitiation();
        }
    };

    const navigateToProfile = () => {
        navigate(`/empleados/${employeeId}`);
    };

    return (
        <div className="my-talent-card__container">
            <div className="my-talent-card__col-1 ">
                <img className="my-talent-card__company-logo" src={signedEmployeeImageUrl} alt={name} />
                <div className="my-talent-card__info">
                    <h3 id="name-applicant-card">{name}</h3>
                </div>
            </div>
            <div className="my-talent-card__col-2-container">
                <div className="my-talent-card__col-2">
                    <div className='my-talent-card__info-container'>
                        <div className="my-talent-card__icon-container">
                        {userChefIcon}
                        </div>
                        <div>
                        <p><strong>Cargo:</strong></p>
                        <p>{position}</p>
                        </div>
                    </div>
                    <div className='my-talent-card__info-container'>
                        <div className="my-talent-card__icon-container">
                        {starIcon}
                        </div>
                        <div>
                        <p><strong>Experiencia:</strong></p>
                        <p>3 años</p>
                        </div>
                    </div>
                </div>
                <div className="my-talent-card__col-2">
                    <div className='my-talent-card__info-container'>
                        <div className="my-talent-card__icon-container">
                        {scheduleIcon}
                        </div>
                        <div>
                        <p><strong>Disponibilidad:</strong></p>
                        <p>{available}</p>
                        </div>
                    </div>
                    <div className='my-talent-card__info-container'>
                        <div className="my-talent-card__icon-container">
                        {timerIcon}
                        </div>
                        <div>
                        <p><strong>Jornada:</strong></p>
                        <p>{schedule}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className='my-talent-card__col-3'>
                <div className="my-talent-card__button-container">
                    <button onClick={navigateToProfile} className="my-talent-card__button">
                        Perfil
                    </button>

                    <button
                        onClick={navigateToChat}
                        className="my-talent-card__button"
                        disabled={conversationLoading}
                    >
                        {conversationLoading ? 'Iniciando...' : 'Chat'}
                    </button>
                    
                    <button
                        onClick={handleDeleteTalent}
                        className='my-talent-card__button'
                    >
                        Borrar
                    </button>
                </div>
                {conversationError && <p className="error-message">{conversationError.message}</p>}
            </div>
        </div>
    );
};

export default MyTalentCard;